import request from '../../utils/request'
import config from '../../../config/config'
// const baseURL = 'http://localhost:3013'
const baseURL = config.baseUrl;

//  信息新增
export function typeAdd (data) {
  return request({
    url: baseURL + 'type/add',
    method: 'post',
    data: data
  })
}
//  信息查询
export function typeList (data) {
  return request({
    url: baseURL + 'type/list',
    method: 'post',
    data: data
  })
}
//  信息删除
export function typeDelete (data) {
  return request({
    url: baseURL + 'type/delete',
    method: 'post',
    data: data
  })
}
//  信息删除
export function typeUpdate (data) {
  return request({
    url: baseURL + 'type/update',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/type/index.js